<script setup lang="ts">
import { onMounted } from "vue";

import type { RouteLocationRaw } from "vue-router";
import { APP_ROUTES } from "@/Generated/Routes/paths";

import AppRouter from "@/Router";
import Routes from "@/Router/Routes";
import { authGuard, notificationsGuard, enableNavigationGuard, initLoguedAppGuard } from "@/Router/guards";

import useAuthStore from "@/Modules/Auth/Store";
import useI18nStore from "@/Modules/i18n/Store";

import { log } from "@/Utils/Debug";
import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";

const authStore = useAuthStore();
const i18nStore = useI18nStore();

onMounted(async () => {
  if (AppRouter.hasRoute("splash")) {
    log("START SPLASH");

    Routes.forEach((route) => AppRouter.addRoute(route));

    AppRouter.removeRoute("splash");
    AppRouter.addBeforeGuard(enableNavigationGuard);
    AppRouter.addBeforeGuard(authGuard);
    AppRouter.addBeforeGuard(notificationsGuard);

    log("SPLASH: END");

    const route = AppRouter.getInstance().currentRoute.value;
    const currentPathName = route.fullPath;
    let initRedirect: RouteLocationRaw | undefined = undefined;

    if (authStore.isUserLogged) {
      initRedirect = await initLoguedAppGuard();
    }

    await i18nStore.selectLocale(i18nStore.getCurrentLocale());

    if (hasValue(initRedirect)) {
      AppRouter.getInstance().push(initRedirect);

      return;
    }

    if (!isValidString(currentPathName) || currentPathName === "/") {
      if (authStore.isUserLogged) {
        AppRouter.getInstance().push({ name: APP_ROUTES.home.root.name });
      } else {
        AppRouter.getInstance().push({ name: APP_ROUTES.login.root.name });
      }
    } else {
      AppRouter.getInstance().push({ path: route.path, query: route.query });
    }
  }
});
</script>

<template>
  <slot />
</template>

<style scoped lang="scss"></style>
